// @flow
import * as React from 'react';
import { Chip } from '@locus-taxy/neo-ui';

import {
    rankWith,
    uiTypeIs,
    or,
    isBooleanView,
    useViewProps,
    type Tester
} from 'platform/settings/form/JsonView';

type Props = {};

const BooleanFieldView = (props: Props): React.Node => {
    const { label } = useViewProps(props);

    return <Chip>{label}</Chip>;
};

export default BooleanFieldView;

export const booleanFieldViewTester: Tester = rankWith(
    1,
    or(uiTypeIs('BooleanFieldView'), isBooleanView)
);
